import { createContext, useContext, useState, useEffect } from "react";

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [activeMainItem, setActiveMainItem] = useState(null);
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    window.addEventListener("closeNavigation", () => {
      closeNavigation();
    });
    return () => {
      window.removeEventListener("closeNavigation", () => {
        closeNavigation();
      });
    };
  }, []);

  const closeNavigation = () => {
    setOpen(false);
    setActiveMainItem(null);
    setActiveItem(null);
  };

  return (
    <NavigationContext.Provider
      value={{
        open,
        setOpen,
        activeMainItem,
        setActiveMainItem,
        activeItem,
        setActiveItem,
        closeNavigation,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};
